import React, { useEffect, useRef, useState } from 'react';
import {
  Grid,
  Container,
  useTheme,
  CardContent,
  CardMedia,
  Card,
  Hidden,
  Divider,
  Dialog,
  Button,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import reviewschool from '../../../assets/reviewschool.png';
import { useNavigate, useParams } from 'react-router-dom';
import banner from '../../../assets/banner.png';
import logo from '../../../assets/white-logo.png';
import Frame from '../../../assets/Frame 37415 (1).png';
import MenuTTdemo from '../../../assets/MenuTTdemo.png';
import menuAlyosef from '../../../assets/alyousef/Menu Image.png';
import TableTuck from '../../../assets/menufilfil.png';
import CategoryBackGround from '../../../assets/menuBackground.png';
import Entrées from '../../../assets/Entrées .png';
import Soups from '../../../assets/Soups and Salad.png';
import Breakfast from '../../../assets/Breakfast.png';
import Manakish from '../../../assets/Manakish.png';
import Kids from '../../../assets/Kids Menu.png';
import Fatayer from '../../../assets/Fatayer.png';
import Popular from '../../../assets/Popular.png';
import APPETIZERS from '../../../assets/APPETIZERS.png';
import Dessert from '../../../assets/Dessert.png';
import Bread from '../../../assets/Bread.png';
import Wraps from '../../../assets/Wraps.png';
import Drinks from '../../../assets/Drinks.png';
import KeyboardDoubleArrowRightTwoToneIcon from '@mui/icons-material/KeyboardDoubleArrowRightTwoTone';
import KeyboardDoubleArrowLeftTwoToneIcon from '@mui/icons-material/KeyboardDoubleArrowLeftTwoTone';

import { borderRadius, Box } from '@mui/system';
import { Link } from 'react-scroll';
import './index.css';
import { useSelector } from 'react-redux';
import { auth } from '../../../../../../libs/firebase-service/src';
import CustomizeDialoge from '../../components/CustomizeDialoge/CustomizeDialoge';
import { environment } from '../../../environments/environment';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../../../../../../libs/components/src';
import {
  LoadItems,
  menues,
  res,
  setModifiers,
  setStores,
  setUser,
  userAddresses,
} from '../../../../../../libs/redux-slices/src';
import { firestore } from '../../../../../../libs/firebase-service/src';
import { useDispatch } from 'react-redux';
import { fetchData } from '../../Utils/UtilsFunctions';
import Loading from 'react-fullscreen-loading';
import { Helmet } from 'react-helmet';
import { FiMinusSquare } from 'react-icons/fi';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { FaShoppingBasket } from 'react-icons/fa';
function MenuItems2() {
  const [t, i18n] = useTranslation();

  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [cat, setCat] = useState([]);
 
  const [isHovered, setIsHovered] = useState(false);
  const [custm, setcustom] = useState('');
  const [extraquantity, setExtraquantity] = useState({});
  const [favorites, setfav] = useState([]);
  const [extraQuantity, setExtraQuantity] = useState({});
  const [defs, setDefs] = useState([]);
  const [items, setItems] = useState([]);
  // Debug: Track Redux and local state for items
  useEffect(() => {
   
    
    // Log item prices for debugging
    if (items && items.length > 0) {
      const itemPrices = items.map(item => ({
        id: item.id,
        name: item.name,
        price: item.price,
        timestamp: new Date().toISOString()
      }));
      
      // Check if we have items with prices from Fatayer category
      const fatayerItems = items.filter(item => 
        item.name && item.name.toLowerCase().includes('fatayer')
      );
      if (fatayerItems.length > 0) {
        fatayerItems.map(item => ({
          name: item.name,
          price: item.price,
          parent_menu_id: item.parent_menu_id
        }));
      }
    }
  }, [items]);
  const modifiers = useSelector((state) => state.shopReducer.modifiers);
  const [data, setData] = React.useState([]);
  const [openn, setOpenn] = useState(false);
  const [calculatedPrices, setCalculatedPrices] = useState({});
  const params = useParams();
  const [enableAdd, setEnableAdd] = useState(false);
  let foundType = false; // Track if 'type' category is found
  const userData = useSelector((state) => state.authReducer.userData);

  const menuess = useSelector((state) => state.authReducer.menues);
  const menuesTimestamp = useSelector((state) => state.authReducer.menuesTimestamp);
  const resTimestamp = useSelector((state) => state.authReducer.resTimestamp);
  const currentItemTimestamp = useSelector((state) => state.shopReducer.currentItemTimestamp);
  const modifiersTimestamp = useSelector((state) => state.shopReducer.modifiersTimestamp);
  const [menuItems, setMenuItems] = useState(null);
  const storess = useSelector((state) => state.shopReducer.stores);
  const [store, setStore] = useState([]);
  const [type, setType] = useState('Popular');
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [hasInitiallyFetched, setHasInitiallyFetched] = useState(false);
  const activeMenu = useSelector((state) => state.authReducer.activeMenu);

  const allactiveMenues = useSelector(
    (state) => state.authReducer.allactiveMenues
  );

  // const items = useSelector((state) => state.shopReducer.currentItem);

  const [option, setOption] = useState(null);

  const categories = useSelector(
    (state) => state.shopReducer.currentCategories
  );


  // Debug: Track menu data changes
  useEffect(() => {
  
    
    if (menuess && menuess.length > 0) {
      // Log category items and their prices
      menuess.forEach((menu, menuIndex) => {
        if (menu.categories) {
          menu.categories.forEach((category, catIndex) => {
            if (category.items && category.items.length > 0) {
              const categoryPrices = category.items.map(item => ({
                name: item.name,
                price: item.price,
                id: item.id
              }));
             
            }
          });
        }
      });
    }
  }, [menuess]);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState('');
  const [item, setItem] = useState(null);
  const [optionsPrice1, setOptionsPrice1] = useState(0);
  const [optionsPrice, setOptionsPrice] = useState(0);
  const [firstModifierPrice, setFirstModifierPrice] = useState(null);

  const user = useSelector((state) => state.authReducer.userData);

  // const userAddresses = useSelector((state) => state.authReducer.userAddresses);
  const [storeId, setStoreId] = useState('');
  const [outofStockDelivery, setOutOfStockDelivery] = useState('');
  const stores = useSelector((state) => state.shopReducer.stores);
  const navRef = useRef(null);

  const getUserAddress = async (token, callback, handleErr) => {
    try {
      await firestore
        .collection('users')
        .doc(user?.uid)
        .collection('addresses')
        .get()
        .then((docs) => {
          let adds = [];
          docs.forEach((doc) => {
            adds.push(doc.data());
          });
          dispatch(userAddresses(adds));
        });
    } catch (e) {
    }
  };

  const getItems = async () => {
    try {
      let ItemsRef = firestore.collection('items');
      let list = [];
      const itemsList = await ItemsRef.where(
        'item_state',
        '==',
        'available'
      ).get();

      itemsList.docs.forEach((doc) => {
        let item = doc.data();
        item.id = doc.id;
        list.push(item);
      });

    
      dispatch(LoadItems(list)); // Updates Redux with timestamp
      setItems(list); // Updates local state
      
    } catch (err) {
    }
  };


  

  const getMenues = async () => {
    try {
     
      setLoading(true);
      const apiUrl = `${environment?.apiUrl}/getMenu?restaurantId=${environment?.restaurantId}`;

  const response = await fetchData(apiUrl, 'get');

  dispatch(res(response.data));


      if (stores?.length === 1) {
        const updatedUser = {
          ...userData,
          defaultStore: stores[0].id,
        };
        dispatch(setUser({ userData: updatedUser }));
        dispatch(menues(response.data[stores[0]?.id]?.menus));
      } else {
        const updatedUser = {
          ...userData,
          defaultStore: userData.defaultStore,
        };
        dispatch(setUser({ userData: updatedUser }));
        dispatch(menues(response.data[userData.defaultStore]?.menus));
      }
    } catch (error) {
    }
    setLoading(false);
  };
  const getModifierss = async () => {
    try {
      
      let modifiersRef = firestore.collection('modifier_groups');
      let list = [];
      const modifierList = await modifiersRef.get();
      for (let index = 0; index < modifierList?.docs?.length; index++) {
        let element = modifierList?.docs[index]?.data();
        element.id = modifierList?.docs[index]?.id;
        list.push(element);
      }
      
      dispatch(setModifiers(list)); // This now includes timestamp
    
      // setModifiersGroups(modifiers);
    } catch (err) {
    }
  };

  const handleNav = (direction) => {
    if (navRef.current) {
      if (direction === 'left') {
        navRef.current.scrollLeft -= 500;
      } else {
        navRef.current.scrollLeft += 500;
      }
    }
  };

  const fetchModifierPrice = async (item) => {
    try {
      // Only apply the new pricing logic if item price is 0
      if (item?.price === 0) {
        // If item has groups array, calculate price from groups
        if (item?.groups && item.groups.length > 0) {
          let totalPrice = 0;

          for (const group of item.groups) {
            if (group.options && group.options.length > 0) {
              // Find the default option in this group
              const defaultOption = group.options.find(
                (option) => option.isDefault === true
              );
              if (defaultOption) {
                totalPrice += defaultOption.price || 0;
              } else {
                // If no default, use the first option
                totalPrice += group.options[0]?.price || 0;
              }
            }
          }

          return totalPrice;
        }

        // Fallback to modifier_group_ids logic for items with price 0 but no groups
        if (
          !item?.modifier_group_ids ||
          item?.modifier_group_ids.length === 0
        ) {
          return 0; // If price is 0 and no modifiers, keep it 0
        }

        const modifierGroupId = item?.modifier_group_ids[0];
        const modifierDoc = await firestore
          .collection('modifier_groups')
          .doc(modifierGroupId)
          .get();

        if (!modifierDoc.exists) {
          return 0;
        }

        let modifierData = modifierDoc.data();

        if (!modifierData.options || modifierData.options.length === 0) {
          return 0;
        }

        // Find the default option or use the first one
        const defaultOption = modifierData.options.find(
          (option) => option.isDefault === true
        );
        const selectedOption = defaultOption || modifierData.options[0];
        const optionPrice = selectedOption?.price || 0;

        return optionPrice;
      } else {
        // For items with price > 0, return the original item price
        return item?.price || 0;
      }
    } catch (error) {
      return item?.price || 0;
    }
  };

  useEffect(() => {
    const fetchPrices = async () => {
      let updatedPrices = { ...calculatedPrices };

      for (const item of items) {
        // Only calculate prices for items with price 0
        if (item?.price === 0) {
          try {
            const newPrice = await fetchModifierPrice(item);
            updatedPrices[item.id] = newPrice;
          } catch (error) {
          }
        }
      }

      setCalculatedPrices(updatedPrices);
    };

    fetchPrices();
  }, [items]);

  useEffect(() => {
    // Only call getUserAddress if user changes and we haven't called it in the main useEffect
    if (user?.uid && auth?.currentUser?.uid && user.uid !== auth.currentUser.uid) {
      getUserAddress(user?.uid);
    }
  }, [user]);

  const getUser = async () => {
    setfav(user?.favorites);
  };

  useEffect(() => {
    getUser();
  }, [auth?.currentUser?.uid, favorites]);

  const addFavorite = async (id) => {
    try {
      let arr = userData?.favorites ? userData.favorites : []; // Default to empty array if undefined
      await firestore
        .collection('users')
        .doc(auth?.currentUser?.uid)
        .set(
          {
            favorites: [...arr, id],
          },
          { merge: true }
        )
        .then(() => {
          const updatedUser = { ...userData, favorites: [...arr, id] };
          dispatch(setUser({ userData: updatedUser }));
        });
    } catch (error) {
    }
  };

  const removeFavoriteTasker = async (taskerID) => {
    try {
      let arr = userData?.favorites ? userData.favorites : []; // Ensure it's always an array

      arr = arr.filter(function (favId) {
        return favId !== taskerID; // Use taskerID for filtering
      });

      await firestore
        .collection('users')
        .doc(auth?.currentUser?.uid)
        .set(
          {
            favorites: arr,
          },
          { merge: true }
        )
        .then(() => {
          const updatedUser = { ...userData, favorites: arr };
          dispatch(setUser({ userData: updatedUser }));
        });
    } catch (error) {
    }
  };

  const handleOpenn = () => {
    setId(id);
    setOpenn(true);
    setItem(item);
  };

  const handleClosee = () => {
    setOpenn(false);
  };

  const getStoreDelivery = async () => {
    if (user?.uid && user?.defaultDeliveryAddress != '')
      (Array.isArray(userAddresses) ? userAddresses : []).map(async (a) => {
        if (a?.id === user?.defaultDeliveryAddress) {
          setStoreId(a?.delivery_store_id);
          storess?.filter((store) => {
            if (store?.id === a?.delivery_store_id) {
              setOutOfStockDelivery(store?.out_of_stock);
            }
          });
        }
      });
  };

  useEffect(() => {
    const fetchPrices = async () => {
      let updatedPrices = { ...calculatedPrices };

      for (const item of items) {
        // Only calculate prices for items with price 0
        if (item?.price === 0) {
          try {
            const newPrice = await fetchModifierPrice(item);
            updatedPrices[item.id] = newPrice;
          } catch (error) {
          }
        }
      }

      setCalculatedPrices(updatedPrices); // Store the updated prices
    };

    fetchPrices();
  }, [items]); // Trigger price calculation whenever the items are fetched or updated

  const getDefaults = async () => {
    try {
      setcustom('');
      setExtraquantity({});
      setDefs([]);
      // let modifiersRef = firestore.collection('modifier_groups');
      // const modifiersList = await modifiersRef.get();
      const item = items.filter((item) => item.id === id)[0];
      
      // For items with price 0, use the same logic as fetchModifierPrice
      if (item?.price === 0) {
        let totalDefaultPrice = 0;
        
        // If item has groups array, calculate price from groups
        if (item?.groups && item.groups.length > 0) {
          for (const group of item.groups) {
            if (group.options && group.options.length > 0) {
              const defaultOption = group.options.find(
                (option) => option.isDefault === true
              );
              const selectedOption = defaultOption || group.options[0];
              
              if (selectedOption) {
                totalDefaultPrice += selectedOption.price || 0;
                
                setExtraquantity((ex) => ({
                  ...ex,
                  [group?.id]: [
                    {
                      customizationMeta: {},
                      defaultQuantity: selectedOption?.minPermitted || 1,
                      id: selectedOption?.id,
                      modifierTitle: selectedOption?.title,
                      price: selectedOption?.price || 0,
                      quantity: 1,
                      title: group?.title || selectedOption?.title,
                    },
                  ],
                }));
                
                setcustom((c) => (c ? c + `, ${selectedOption.title}` : selectedOption.title));
                setDefs((defs) =>
                  defs.length
                    ? [...defs, [group?.title || selectedOption?.title, selectedOption.title]]
                    : [[group?.title || selectedOption?.title, selectedOption.title]]
                );
              }
            }
          }
        } else {
          // Handle items with modifier_group_ids for price 0 items
          const mods = modifiers?.filter((mod) =>
            item?.modifier_group_ids.includes(mod?.id)
          );
          
          const perimits = mods?.filter((opt) => opt?.minPermitted != 0);
          if (perimits) {
            for (const perimite of perimits) {
              const defaultOption = perimite?.options?.find((o) => o.isDefault === true);
              const selectedOption = defaultOption || perimite?.options?.[0];
              
              if (selectedOption) {
                totalDefaultPrice += selectedOption.price || 0;
                
                setExtraquantity((ex) => ({
                  ...ex,
                  [perimite?.id]: [
                    {
                      customizationMeta: {},
                      defaultQuantity: selectedOption?.minPermitted || 1,
                      id: selectedOption?.id,
                      modifierTitle: perimite?.title,
                      price: selectedOption?.price || 0,
                      quantity: 1,
                      title: selectedOption?.title,
                    },
                  ],
                }));
                
                setcustom((c) => (c ? c + `, ${selectedOption.title}` : selectedOption.title));
                setDefs((defs) =>
                  defs.length
                    ? [...defs, [perimite?.title, selectedOption.title]]
                    : [[perimite?.title, selectedOption.title]]
                );
              }
            }
          }
        }
        
        setOptionsPrice1(totalDefaultPrice);
        setOptionsPrice(0); // For price 0 items, we don't have additional options price
      } else {
        // Original logic for items with price > 0
        const mods = modifiers?.filter((mod) =>
          item?.modifier_group_ids.includes(mod?.id)
        );

        const perimits = mods?.filter((opt) => opt?.minPermitted != 0);
        if (perimits) {
          let p = 0;
          let o = 0;
          for (const perimite of perimits) {
            for (const opt of perimite?.options) {
              if (opt.isDefault) {
                setOption(opt);
                setExtraquantity((ex) => ({
                  ...ex,
                  [perimite?.id]: [
                    {
                      customizationMeta: {},
                      defaultQuantity: opt?.minPermitted,
                      id: opt.id,
                      modifierTitle: opt.title,
                      price: opt.price,
                      quantity: 1,
                      title: perimite?.title,
                    },
                  ],
                }));
                if (
                  perimite?.minPermitted == 1 &&
                  perimite?.maxPermittedUnique == 1
                ) {
                  p = p + perimite?.options?.find((o) => o.isDefault)?.price;
                }
                if (
                  perimite?.minPermitted > 0 &&
                  perimite?.maxPermittedUnique != 1
                ) {
                  o = o + opt?.price;
                }
                setcustom((c) => (c ? c + `, ${opt.title}` : opt.title));
                setDefs((defs) =>
                  defs.length
                    ? [...defs, [perimite?.title, opt.title]]
                    : [[perimite?.title, opt.title]]
                );
              }
            }
          }
          setOptionsPrice1(p > 0 ? p : 0);
          setOptionsPrice(o > 0 ? o : 0);
          if (perimits?.length > 0 && perimits[0]?.options?.length > 0) {
            setFirstModifierPrice(perimits[0]?.options[0]?.price);
          }
        }
      }
    } catch (err) {
    }
  };

  const getModifiers = async () => {
    setData(modifiers);
  };

  const handleFavoriteClick = (itemId) => {
    if (!auth?.currentUser) {
      navigate('/signup');
      return;
    }

    if (userData?.favorites?.includes(itemId)) {
      removeFavoriteTasker(itemId);
    } else {
      addFavorite(itemId);
    }
  };
  const handleOpen = (id, item) => {
    setId(id);
    setOpen(true);
    setItem(item);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeType = async (value) => {
    setType(value);
  };

  useEffect(() => {
    getStoreDelivery();
  }, [outofStockDelivery]);

  useEffect(() => {
    if (items?.length) {
      getDefaults();
    }
  }, [id, items?.length]);

  useEffect(() => {
    // Only call getModifiers on initial load, and only if we haven't fetched yet
    if (!hasInitiallyFetched) {
      getModifiers();
    }
    // getModifierss(); // Already called in main useEffect above - avoid duplicate
  }, [hasInitiallyFetched]);

  useEffect(() => {
    (async () => {
      if (params.id == null) {
        setOpen(false);
      } else {
        let item = items?.find((item) => item?.id === params?.id);
        handleOpen(item?.id, item);
      }
    })();
  }, [params.id]);

  useEffect(() => {
    menuess?.map((c) =>
      c.categories?.map((category, index) => {
        if (index == 1 && c?.categories[0]?.items?.length == 0) {
          setType(c?.categories[1]?.id);
        }
      })
    );
  }, [menuess]);

  // useEffect(() => {
  //   if (menuess === undefined || menuess?.length === 0) {
  //     setLoading(true);
  //     fetchDataIfNeeded();
  //   }
  //   // setLoading(false);
  // }, [storess, menuess]);

  // Always fetch fresh data on page load
  useEffect(() => {
    if (!hasInitiallyFetched) {
      getUserAddress(auth?.currentUser?.uid);
      getItems();
      getMenues();
      getModifierss();
      setHasInitiallyFetched(true);
    }
  }, []);

  return (
    <>
      {environment?.restaurantId === 'istanbulDk' ||
        (environment.restaurantId === 'taqwasbakery' && (
          <Helmet>
            <title>Taqwa's Bakery and Restaurant | Menu</title>
          </Helmet>
        ))}
      <div
        style={{
          backgroundColor: '#050505FC',
          position: 'relative',
          width: '100%',
          height: '450px',
          backgroundImage:
            environment.restaurantId === 'alyousef'
              ? `url(${menuAlyosef})`
              : environment.restaurantId === 'filfil'
              ? `url(${TableTuck})`
              : environment.restaurantId === 'ttDemo'
              ? `url(${MenuTTdemo})`
              : environment.restaurantId === 'istanbulDk'
              ? `url(${banner})`
              : environment.restaurantId === 'taqwasbakery'
              ? `url(${banner})`
              : `url(${reviewschool})`,
          // MenuTTdemo

          backgroundRepeat: 'no-repeat',
        }}
      >
        <div>
          <a href="https://taqwasbakery.com/" style={{ position: 'relative' }}>
            <img
              src={logo}
              alt="logo"
              style={{
                paddingTop: smDown ? '50px' : '10px',
                paddingLeft: '20px',
                display: 'flex',
                cursor: 'pointer',
                width: '6rem',
                position: 'relative',
                zIndex: 1500,
              }}
            />
          </a>
        </div>
        <img
          src={Frame}
          alt="title"
          style={{
            position: 'absolute',
            top: '40%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
      <div className="menu-container" style={{ backgroundColor: '#050505FC' }}>
        <div>
          {menuess?.length > 5 ? (
            <button onClick={() => handleNav('left')}>
              <p className="fa fa-lg fa-chevron-left">
                <KeyboardDoubleArrowLeftTwoToneIcon />
              </p>
            </button>
          ) : (
            ''
          )}
        </div>
        <div
          className="nav-items"
          ref={navRef}
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            padding: '1rem',
            scrollSnapType: 'x mandatory',
            alignItems: 'stretch',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}
        >
          {menuess?.map((c) => (
            <div>
              {c.categories?.length > 0 &&
                c.categories?.map((category, index) => (
                  <Grid
                    item
                    lg={4}
                    style={{
                      display: 'inline-block',
                      color: 'white',
                      textAalign: 'center',
                      padding: '14px',
                      textDecoration: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    <Card
                      key={category.id}
                      style={{
                        border: '2px solid lightgray',
                        borderRadius: '20px',
                        backgroundColor: '#151414',

                        borderColor:
                          type === category?.id && category?.items?.length !== 0
                            ? '#252525'
                            : '#252525',
                        width: smDown ? '120px' : '140px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleChangeType(category.id);
                        setEnableAdd(false);
                      }}
                    >
                      <CardContent
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          textAlign: 'center',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <img
                          src={category.category_image_thumb_url}
                          alt={category.category_image_thumb_url}
                          style={{ width: '60px', height: '60px' }}
                        />
                        <Typography
                          variant="body1"
                          style={{
                            fontWeight: 'bold',
                            color: 'white',
                            whiteSpace: isHovered ? 'normal' : 'nowrap',
                            overflow: isHovered ? 'visible' : 'hidden',
                            textOverflow: isHovered ? 'unset' : 'ellipsis',
                            width: '150px',
                            cursor: 'pointer',
                          }}
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                          title={category.name}
                        >
                          {category.name?.length > 12
                            ? category.name.slice(0, 12)
                            : category.name}
                          {category.name?.length > 12 ? '...' : ''}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
            </div>
          ))}
        </div>
        <div>
          {menuess?.length > 5 ? (
            <button onClick={() => handleNav('right')}>
              <p className="fa fa-lg fa-chevron-right">
                <KeyboardDoubleArrowRightTwoToneIcon />
              </p>
            </button>
          ) : (
            ''
          )}
        </div>
      </div>

      {menuess?.map((c) => (
        <div style={{ backgroundColor: '#050505FC' }}>
          {c.categories?.length > 0 &&
            c.categories?.map(
              (category, index) =>
                category.id === type && (
                  <>
                    <Box
                      key={category.id}
                      container
                      sx={{
                        height: '300px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundImage:
                          category?.name === 'Breakfast'
                            ? `url(${Breakfast})`
                            : category?.name === 'Fatayer / فطاير'
                            ? `url(${Fatayer})`
                            : category?.name === 'Manakish / مناقيش'
                            ? `url(${Manakish})`
                            : category?.name === 'Dessert'
                            ? `url(${Dessert})`
                            : category?.name === 'Soups and Salads'
                            ? `url(${Soups})`
                            : category?.name === 'Hot Appetizers / مقبلات'
                            ? `url(${APPETIZERS})`
                            : category?.name === 'Cold Appetizers / مقبلات'
                            ? `url(${APPETIZERS})`
                            : category?.name === 'Kids Menu'
                            ? `url(${Kids})`
                            : category?.name === 'Bread'
                            ? `url(${Bread})`
                            : category?.name === 'Wraps'
                            ? `url(${Wraps})`
                            : category?.name === 'Drinks'
                            ? `url(${Drinks})`
                            : category?.name === 'Entrées / الأطباق الرئيسية'
                            ? `url(${Entrées})`
                            : category?.name === 'Popular'
                            ? `url(${Popular})`
                            : `url(${CategoryBackGround})`,

                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        marginLeft: smDown ? '-10px' : '0px',
                        marginBottom: smDown ? '30px' : '60px',
                        position: 'relative',
                      }}
                    >
                      <div
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: 'rgba(0, 0, 0, 0.5)',
                          filter: 'blur(5px)',
                          zIndex: -1,
                        }}
                      />

                      <Typography
                        variant={'h4'}
                        sx={{
                          fontFamily: 'Cormorant Infant',
                          color: 'white',
                          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.6)',
                          position: 'absolute',
                          bottom: '70px',
                          left: '50px',
                          zIndex: 2,
                          fontSize: '40px',
                          '@media (max-width: 600px)': {
                            fontSize: '25px',
                          },
                        }}
                      >
                        {category?.name}

                        <span
                          style={{
                            display: 'block',
                            width: '100%',
                            height: '20px',
                            backgroundColor: '#D92B2A',
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            zIndex: 1,
                          }}
                        />
                      </Typography>
                    </Box>

                    <Container maxWidth={'lg'} sx={{ paddingBottom: '200px' }}>
                      <div id={category?.id} key={index}>
                        {
                          <>
                            {' '}
                            <Grid
                              container
                              spacing={1}
                              direction="row"
                              sx={{
                                display: { sm: 'block', lg: 'flex' },
                              }}
                            >
                              {category.items?.length > 0 &&
                                category.items?.map(
                                  (item, index) =>
                                    // item.parent_menu_id === category.id &&
                                    item.item_state === 'available' && (
                                      <>
                                        {environment?.restaurantId ===
                                        'elmbrookschools' ? (
                                          <Grid
                                            key={item.id}
                                            item
                                            lg={3}
                                            sm={6}
                                            style={{
                                              marginTop: '30px',
                                              marginBottom: '50px',
                                              display: 'grid',
                                            }}
                                          >
                                            <div
                                              onClick={() =>
                                                handleOpen(item?.id, item)
                                              }
                                            ></div>
                                            <div className="menu-item-image-container">
                                              <div
                                                className="menu-item-image-circle"
                                                style={{
                                                  backgroundColor: '#fadcbb',
                                                  borderRadius: '100px',
                                                  width: '200px',
                                                  backgroundImage:
                                                    ' linear-gradient(to top, #FBF1EA, #FBF1EA, #FFFDFC, #FFFDFC, #FFFDFC)',
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                  }}
                                                >
                                                  <img
                                                    src={item?.item_image_url}
                                                    alt="Menu Item"
                                                    style={{
                                                      height: '80%',
                                                      width: '80%',
                                                    }}
                                                  />
                                                </div>

                                                <div
                                                  style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '10px',
                                                  }}
                                                >
                                                  <Button
                                                    variant="contained"
                                                    style={{
                                                      backgroundColor: 'white',
                                                      color:
                                                        environment.primaryColor,
                                                      borderRadius: '30px',
                                                    }}
                                                    onClick={() =>
                                                      handleOpen(item?.id, item)
                                                    }
                                                  >
                                                    Add to cart
                                                  </Button>
                                                </div>
                                              </div>
                                              <div
                                                style={{
                                                  width: '64%',
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  textAlign: 'center',
                                                }}
                                              >
                                                <Typography
                                                  variant="h5"
                                                  style={{
                                                    color:
                                                      environment.primaryColor,
                                                  }}
                                                >
                                                  {item?.name}
                                                </Typography>
                                              </div>
                                            </div>
                                          </Grid>
                                        ) : (
                                          <>
                                            {' '}
                                            <Hidden smDown>
                                              <Grid item sm={12} lg={6}>
                                                <div
                                                  onClick={() =>
                                                    handleOpen(item?.id, item)
                                                  }
                                                  style={{ cursor: 'pointer' }}
                                                >
                                                  <div className="menu-item-details">
                                                    <Grid item lg={8} xl={8}>
                                                      <Typography
                                                        variant={'body1'}
                                                        style={{
                                                          fontWeight: 'bold',
                                                          color: '#833720',
                                                          display: 'flex',
                                                        }}
                                                      >
                                                        {item.isCatering ? (
                                                          <>
                                                            <FiMinusSquare
                                                              style={{
                                                                marginTop:
                                                                  '4px',
                                                                marginRight:
                                                                  '3px',
                                                              }}
                                                            />
                                                            {'Catering'}
                                                          </>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Typography>
                                                    </Grid>
                                                    <div
                                                      className="menu-item-image-container"
                                                      style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginBottom: '20px',
                                                        height: '100px',
                                                        justifyContent:
                                                          'space-between', // Spread items across the container
                                                        gap: '1rem',
                                                        width: '100%', // Ensure it spans the full width
                                                      }}
                                                    >
                                                      {/* Image Section */}
                                                      <img
                                                        src={
                                                          item?.item_image_url
                                                        }
                                                        style={{
                                                          borderRadius: '50%',
                                                          width: '80px',
                                                          height: '80px',
                                                        }}
                                                        alt="Menu Item"
                                                        className="menu-item-image"
                                                      />

                                                      {/* Item Info Section */}
                                                      <div style={{ flex: 1 }}>
                                                        {' '}
                                                        {/* Allows content to grow while keeping button aligned */}
                                                        <h6
                                                          className="menu-item-title"
                                                          style={{
                                                            color: '#D6D6D6',
                                                            fontFamily:
                                                              'Outfit',
                                                            fontWeight: 500,
                                                            fontSize: '20px',
                                                          }}
                                                        >
                                                          {item?.name}
                                                        </h6>
                                                        <p
                                                          className="menu-item-description"
                                                          style={{
                                                            color: '#9C9C9C',
                                                            fontFamily:
                                                              'Outfit',
                                                            fontWeight: 400,
                                                            fontSize: '14px',
                                                          }}
                                                        >
                                                          {item?.description
                                                            .length > 99
                                                            ? item?.description.slice(
                                                                0,
                                                                99
                                                              )
                                                            : item?.description}
                                                          {item?.description
                                                            .length > 99
                                                            ? '...'
                                                            : ''}
                                                        </p>
                                                      </div>

                                                      <Box
                                                        sx={{
                                                          width: '40px',
                                                          height: '40px',
                                                          borderRadius: '50%',
                                                          backgroundColor:
                                                            '#3A3232FC',
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          justifyContent:
                                                            'center',
                                                          cursor: 'pointer',
                                                          marginTop: '40px',
                                                        }}
                                                        onClick={() =>
                                                          handleFavoriteClick(
                                                            item?.id
                                                          )
                                                        }
                                                      >
                                                        {user?.favorites?.includes(
                                                          item?.id
                                                        ) ? (
                                                          <FavoriteIcon
                                                            sx={{
                                                              color: '#A01913',
                                                            }}
                                                          />
                                                        ) : (
                                                          <FavoriteBorderIcon
                                                            sx={{
                                                              color: '#fff',
                                                            }}
                                                          />
                                                        )}
                                                      </Box>
                                                      {/* Button Section */}
                                                      <div
                                                        style={{
                                                          display: 'flex',
                                                          flexDirection:
                                                            'column',
                                                          alignItems:
                                                            'flex-end',
                                                          justifyContent:
                                                            'flex-end',
                                                          marginTop: '0px',
                                                        }}
                                                      >
                                                        <h6
                                                          className="menu-item-title"
                                                          style={{
                                                            color: '#A01913',
                                                            fontFamily:
                                                              'Outfit',
                                                            fontWeight: 700,
                                                            fontSize: '18px',
                                                            marginBottom:
                                                              '10px',
                                                          }}
                                                        >
                                                          $
                                                          {item?.price === 0
                                                            ? calculatedPrices[
                                                                item.id
                                                              ] || '0.05'
                                                            : item?.price?.toFixed(
                                                                2
                                                              )}
                                                        </h6>
                                                        <button
                                                          onClick={() =>
                                                            handleOpen(
                                                              item?.id,
                                                              item
                                                            )
                                                          }
                                                          style={{
                                                            backgroundColor:
                                                              '#A01913',
                                                            color: 'white',
                                                            padding: '8px 25px',
                                                            borderRadius:
                                                              '30px',
                                                            display: 'flex',
                                                            alignItems:
                                                              'center',
                                                            justifyContent:
                                                              'center',
                                                            fontFamily:
                                                              'Outfit',
                                                            gap: '8px',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                          }}
                                                        >
                                                          <FaShoppingBasket
                                                            style={{
                                                              color: '#ffffff',
                                                              fontSize: '14px',
                                                            }}
                                                          />
                                                          <span
                                                            style={{
                                                              fontSize: '14px',
                                                            }}
                                                          >
                                                            {t('menu.add')}
                                                          </span>
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <Divider
                                                  sx={{
                                                    borderColor: '#2E2E2E',
                                                    marginY: '10px',
                                                    mx: '10px',
                                                    height: '1px',
                                                  }}
                                                />
                                              </Grid>
                                            </Hidden>
                                            {/* //in mobile */}
                                            {/* Text content */}
                                            <Hidden smUp>
                                              <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                lg={12}
                                              >
                                                <div
                                                  onClick={() =>
                                                    handleOpen(item?.id, item)
                                                  }
                                                  className="menu-item-image-container"
                                                  style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginBottom: '20px',
                                                    justifyContent:
                                                      'space-between',
                                                    gap: '1rem',
                                                    width: '100%',
                                                    height: 'auto',
                                                    flexWrap: 'wrap',
                                                    cursor: 'pointer',
                                                  }}
                                                >
                                                  {/* Image Section */}
                                                  <img
                                                    src={item?.item_image_url}
                                                    style={{
                                                      borderRadius: '50%',
                                                      width: '80px',
                                                      height: '80px',
                                                    }}
                                                    alt="Menu Item"
                                                    className="menu-item-image"
                                                  />

                                                  {/* Text and Actions Container */}
                                                  <Grid
                                                    container
                                                    spacing={1}
                                                    sx={{ flexGrow: 1 }}
                                                  >
                                                    {/* Title and Favorite Icon */}
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      sm={12}
                                                      md={8}
                                                      sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent:
                                                          'space-between',
                                                      }}
                                                    >
                                                      <h6
                                                        className="menu-item-title"
                                                        style={{
                                                          color: '#D6D6D6',
                                                          fontFamily: 'Outfit',
                                                          fontWeight: 500,
                                                          fontSize: '16px', // Adjusted for mobile
                                                          flexGrow: 1,
                                                        }}
                                                      >
                                                        {item?.name}
                                                      </h6>

                                                      {/* Favorite Icon */}
                                                      <Box
                                                        sx={{
                                                          width: '40px',
                                                          height: '40px',
                                                          borderRadius: '50%',
                                                          backgroundColor:
                                                            '#3A3232FC',
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          justifyContent:
                                                            'center',
                                                          cursor: 'pointer',
                                                        }}
                                                        onClick={() =>
                                                          handleFavoriteClick(
                                                            item?.id
                                                          )
                                                        }
                                                      >
                                                        {user?.favorites?.includes(
                                                          item?.id
                                                        ) ? (
                                                          <FavoriteIcon
                                                            sx={{
                                                              color: '#b71c1c',
                                                            }}
                                                          />
                                                        ) : (
                                                          <FavoriteBorderIcon
                                                            sx={{
                                                              color: '#fff',
                                                            }}
                                                          />
                                                        )}
                                                      </Box>
                                                    </Grid>

                                                    {/* Description */}
                                                    <Grid item xs={12} sm={12}>
                                                      <p
                                                        className="menu-item-description"
                                                        style={{
                                                          color: '#9C9C9C',
                                                          fontFamily: 'Outfit',
                                                          fontWeight: 400,
                                                          fontSize: '14px',
                                                        }}
                                                      >
                                                        {item?.description
                                                          .length > 99
                                                          ? item?.description.slice(
                                                              0,
                                                              99
                                                            ) + '...'
                                                          : item?.description}
                                                      </p>
                                                    </Grid>

                                                    {/* Add to Cart Button */}
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      sm={12}
                                                      md={4}
                                                      sx={{
                                                        display: 'flex',
                                                        justifyContent:
                                                          'flex-end',
                                                      }}
                                                    >
                                                      <button
                                                        onClick={() =>
                                                          handleOpen(
                                                            item?.id,
                                                            item
                                                          )
                                                        }
                                                        style={{
                                                          backgroundColor:
                                                            environment.mainColor,
                                                          color: 'white',
                                                          padding: '8px 25px',
                                                          borderRadius: '30px',
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          justifyContent:
                                                            'center',
                                                          gap: '8px',
                                                          border: 'none',
                                                          cursor: 'pointer',
                                                        }}
                                                      >
                                                        <FaShoppingBasket
                                                          style={{
                                                            color: '#ffffff',
                                                            fontSize: '14px',
                                                          }}
                                                        />
                                                        <span
                                                          style={{
                                                            fontSize: '14px',
                                                          }}
                                                        >
                                                          {t('menu.add')}
                                                        </span>
                                                      </button>
                                                    </Grid>
                                                  </Grid>
                                                </div>

                                                <Divider
                                                  sx={{
                                                    borderColor: '#2E2E2E',
                                                    marginY: '10px',
                                                    mx: '10px',
                                                    height: '1px',
                                                  }}
                                                />
                                              </Grid>
                                            </Hidden>
                                            {/* Image */}
                                            {/* Divider */}
                                            {/* ====== */}
                                          </>
                                        )}

                                        {item?.id === id ? (
                                          <CustomizeDialoge
                                            open={open}
                                            handleClose={handleClose}
                                            option={option}
                                            c={item}
                                            priceToShow={
                                              item?.price === 0 
                                                ? calculatedPrices[item?.id] || 0
                                                : item?.price + optionsPrice1
                                            }
                                            data={data}
                                            defs={defs}
                                            defaultPrices={
                                              item?.price === 0 
                                                ? calculatedPrices[item?.id] || 0
                                                : optionsPrice1
                                            }
                                            extraQuantity={extraQuantity}
                                            setExtraQuantity={setExtraQuantity}
                                            outofStockDelivery={
                                              outofStockDelivery
                                            }
                                            openn={openn}
                                            handleClosee={handleClosee}
                                            handleOpenn={handleOpenn}
                                            enableAdd={enableAdd}
                                          />
                                        ) : (
                                          ''
                                        )}
                                      </>
                                    )
                                )}
                            </Grid>
                          </>
                        }
                      </div>
                    </Container>
                  </>
                )
            )}
        </div>
      ))}

      <Loading
        loading={!!loading}
        background="rgba(86, 100, 210, 0.1)"
        loaderColor={environment.mainColor}
      />
    </>
  );
}
export default MenuItems2;
